import React, { useEffect, useState } from 'react';
import axios from 'axios';
import useAuth from '../hooks/useAuth';

const UserProfile = () => {
  const { user, displayName } = useAuth();
  const [activeUser, setActiveUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Use environment variables for API URL
  const API_BASE_URL = process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_PRODUCTION_API_BASE_URL
    : process.env.REACT_APP_DEVELOPMENT_API_BASE_URL;
  const PORT = process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_PRODUCTION_PORT
    : process.env.REACT_APP_DEVELOPMENT_PORT;

  useEffect(() => {
    console.debug('API_BASE_URL:', API_BASE_URL, 'PORT:', PORT, 'user:', user);
    if (user && user.id) {
      axios.get(`${API_BASE_URL}:${PORT}/api/discord/user/${user.id}`)
        .then(({ data }) => {
          console.debug('User data:', data);
          setActiveUser(data);
        })
        .catch((err) => {
          console.error('Error fetching user data:', err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [user, API_BASE_URL, PORT]);    

  if (loading) return <div>Loading...</div>;
  if (!activeUser) return <div>Error loading user data.</div>;

  return (
    <div className="page-container">
      <div className="home-container">
        <h1>Welcome {displayName}</h1>
        <p>This page displays your user information and settings:</p>
        <pre>{JSON.stringify(activeUser, null, 2)}</pre>
      </div>
    </div>
  );
};

export default UserProfile;
